import { useState, useMemo } from 'react'
import { View, Text, TouchableOpacity, Modal, ScrollView, StyleSheet } from 'react-native'
import { useTranslation } from 'react-i18next'
import { colors, fonts, radius } from '../../lib/theme'
import { useThemeColors } from '../../lib/useThemeColors'
import Ionicons from '@expo/vector-icons/Ionicons'
export default function PickModal({ player, onClose }) {
  const tc = useThemeColors()
  const styles = useMemo(() => makeStyles(tc), [tc])
  const { t } = useTranslation()

  return (
    <Modal visible transparent animationType="slide" onRequestClose={onClose}>
      <View style={styles.wrapper}>
        <TouchableOpacity style={styles.overlay} activeOpacity={1} onPress={onClose} />
        <View style={[styles.sheet, { backgroundColor: tc.bgCard, borderColor: tc.border }]}>
          <View style={styles.handle} />
          <View style={styles.header}>
            <Text style={styles.title}>{player.name}</Text>
            <TouchableOpacity style={styles.closeBtn} onPress={onClose}>
              <Ionicons name="close" size={16} color={tc.textMuted} />
            </TouchableOpacity>
          </View>
          <ScrollView contentContainerStyle={{ padding: 16, paddingBottom: 32 }}>
            {player.picks.length === 0 ? (
              <Text style={styles.empty}>{t('pick.no_pick_found')}</Text>
            ) : (
              player.picks.map((p, i) => (
                <View key={i} style={styles.pickRow}>
                  <View style={styles.slotBadge}>
                    <Text style={styles.slotText}>{p.slot}</Text>
                  </View>
                  <Text style={styles.riderName}>{p.name}</Text>
                </View>
              ))
            )}
          </ScrollView>
        </View>
      </View>
    </Modal>
  )
}

const makeStyles = (tc) => StyleSheet.create({
  wrapper: { flex: 1, justifyContent: 'flex-end' },
  overlay: { ...StyleSheet.absoluteFillObject, backgroundColor: 'rgba(0,0,0,0.6)' },
  sheet: { borderTopLeftRadius: 20, borderTopRightRadius: 20, borderWidth: 1, minHeight: '55%', maxHeight: '85%' },
  handle: { width: 36, height: 4, backgroundColor: tc.border, borderRadius: 2, alignSelf: 'center', marginTop: 10, marginBottom: 4 },
  header: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', padding: 16, borderBottomWidth: 1, borderBottomColor: tc.border },
  title: { fontFamily: fonts.condensedBold, fontSize: 16, color: tc.text, textTransform: 'uppercase' },
  closeBtn: { backgroundColor: tc.bgCard2, borderWidth: 1, borderColor: tc.border, borderRadius: radius.md, width: 32, height: 32, alignItems: 'center', justifyContent: 'center' },
  closeBtnText: { color: tc.textMuted, fontSize: 14 },
  empty: { color: tc.textMuted, fontSize: 13, textAlign: 'center', paddingVertical: 20 },
  pickRow: { flexDirection: 'row', alignItems: 'center', gap: 14, backgroundColor: tc.bgCard2, borderRadius: radius.lg, padding: 14, paddingHorizontal: 16, marginBottom: 10, borderWidth: 1, borderColor: tc.border },
  slotBadge: { width: 28, height: 28, borderRadius: 14, backgroundColor: tc.rosa, alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  slotText: { color: tc.brandText, fontFamily: fonts.condensedBold, fontSize: 13 },
  riderName: { fontSize: 15, color: tc.text, fontWeight: '600' },
})